import { EnterAnimationStartEvent, TransitionStartEvent } from '@mockly/events';

const selectors = {
  sections: '.shopify-section',
  header: 'site-header'
}

class SectionObserver {
  #sections = null;
  #header = null;
  #observer = null;
  #direction = 'up';
  #lastY = 0;

  constructor() {
    this.handlePageChange = this.handlePageChange.bind(this);
    this.destroyObserver = this.destroyObserver.bind(this);

    document.addEventListener('DOMContentLoaded', () => {
      this.init();
    });
  }

  destroyObserver() {
    this.#observer?.disconnect();
    this.#observer = null;
    this.#sections = null;
    this.#header = null;
    this.#lastY = 0;
  }

  handlePageChange() {
    this.#setupObserver();
  }

  #getTargetSection(target) {
    if (target.nextElementSibling && this.#direction === 'down') return target.nextElementSibling;

    return target;
  }

  #setScrollDirection() {
    const currentY = window.scrollY;
    
    this.#direction = currentY > this.#lastY ? 'down' : 'up';
    this.#lastY = currentY;
  }

  #updateTheme(target) {
    const isLight = target.classList.contains('section-theme-light');
    
    this.#header.setAttribute('data-theme', isLight ? 'light' : 'dark');
  }

  #shouldUpdate(entry) {
    if (this.#direction === 'down' && !entry.isIntersecting) return true;

    if (this.#direction === 'up' && entry.isIntersecting) return true;

    return false;
  }

  #setupObserver() {
    this.#sections = document.querySelectorAll(selectors.sections);
    this.#header = document.querySelector(selectors.header);
    
    this.#observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        this.#setScrollDirection();

        if (!this.#shouldUpdate(entry)) return;
        
        const target = this.#getTargetSection(entry.target);
        this.#updateTheme(target);
      });
    }, {
      rootMargin: `${(this.#header.offsetHeight / 2) * -1}px`,
      threshold: 0
    });

    this.#sections.forEach((section) => {
      this.#observer.observe(section);
    });
  }

  init() {
    this.#setupObserver();

    window.addEventListener(EnterAnimationStartEvent.eventName, this.handlePageChange);
    window.addEventListener(TransitionStartEvent.eventName, this.destroyObserver);
  }
}

const sectionObserver = new SectionObserver();
export default sectionObserver;